var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"border":"1px solid #ccc"}},[_c('Toolbar',{staticStyle:{"border-bottom":"1px solid #ccc"},attrs:{"default-config":{
      excludeKeys: ['fullScreen', 'uploadImage', 'uploadVideo']
    },"editor":_vm.editor}}),_c('Editor',{staticStyle:{"height":"480px","overflow-y":"hidden"},attrs:{"default-config":{
      placeholder: '请输入内容...'
    }},on:{"onChange":_vm.onChange,"onCreated":_vm.onCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }